<div class="pme-container">
    <pme-window-shop-manager-header *ngIf="this.headerContent" [headerContent]="this.headerContent">
    </pme-window-shop-manager-header>

    <div class="selector display-utils-row display-utils-center-center display-utils-gap-8">
        <pme-product-selector *ngIf="periodicityList?.length > 1" [titlesToggles]="periodicityList" 
            (selectionChanged)="onSelectionChanged($event)"></pme-product-selector>
    </div>

    <div class="display-utils-row display-utils-lt-md-col display-utils-center-center display-utils-gap-16" style="margin-top: 16px;">
        <div class="pme-carousel-swiper-container display-utils-lt-md-flex-100 display-utils-gt-md-flex-85">
            <ng-container *ngIf="currentPlans">
                <pme-carousel-swiper [identifier]="'monitore-plans'" [items]="currentPlans">
                    <ng-template let-plan let-i="index">
                        <pme-product-monitore  [shopWindowItem]="plan"  [periodicity]="[periodicityList[selectedToggle]]" 
                            (clickOnProduct)="navigate(i)">
                             </pme-product-monitore>
                    </ng-template>
                </pme-carousel-swiper>
            </ng-container>
        </div>
    </div>

   


    <div class="footer-product-listing">
        <p class="footer-product-listing" *ngFor="let footer of productListingFooter" >
            {{ footer }}
        </p>
    </div>

    <pme-window-shop-manager-nutrition-table *ngIf="this.tableNutritionContent"
        [tableNutritionContent]="this.tableNutritionContent"></pme-window-shop-manager-nutrition-table>

    <div class="choose-plan-button display-utils-col display-utils-center-center display-utils-gap-8">
        <button (click)="onChoosePlan()"><p>ESCOLHA SEU PLANO</p></button>
    </div>

    <div class="legal-notes display-utils-col display-utils-center-center display-utils-gap-8">
        <p *ngFor="let note of legalNotes">{{ note }}</p>
    </div>
    <mat-divider class="divider"></mat-divider>
    <pme-payment-methods></pme-payment-methods>

</div>